import script from "./PanelOptionsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelOptionsCard.vue?vue&type=script&setup=true&lang=js"

import "./PanelOptionsCard.vue?vue&type=style&index=0&id=9d0e5806&lang=scss"

export default script